import { useAtomValue } from "jotai";
import React from "react";

import { InfoBanner } from "@whoosh/design-system/src/components/display/InfoBanner/InfoBanner";
import { InfoIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { waitlistWarningMessageAtom } from "../../../../atoms/selectors/waitlistWarningMessageAtom/waitlistWarningMessageAtom";

export const WaitlistWarningBanner = () => {
  const message = useAtomValue(waitlistWarningMessageAtom);
  return message ? (
    <Box paddingTop={4}>
      <InfoBanner
        message={message}
        colorTheme="WARNING"
        leadingIcon={InfoIcon}
      />
    </Box>
  ) : null;
};
